import { Model } from '@vuex-orm/core';
import Option from '@/models/Option';
import OptionVariable from '@/models/OptionVariable';

export default class OptionCategory extends Model {
  static entity = 'option_categories';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      extraInfo: this.boolean(false),
      longTitle: this.attr(null),
      longDescription: this.attr(null),

      selectedOptions: this.attr(null),

      // Relationship IDs
      options: this.hasMany(Option, 'option_category_id'),
      optionVariable: this.hasMany(OptionVariable, 'option_category_id'),
    };
  }

  static transformer(data) {
    const optionCategories = [];
    data.data.forEach(item => {
      const category = {};
      category.id = item.id;
      category.name = item.name;
      category.slug = item.slug;
      category.count = item.count;
      category.description = item.description;
      if (item.acf.extra_info_check === 'true') {
        category.extraInfo = true;
      
        if (item.acf.long_title) {
          category.longTitle = item.acf.long_title;
        }

        if (item.acf.long_description) {
          category.longDescription = item.acf.long_description;
        }
      }
      optionCategories.push(category);
    });
    return optionCategories;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/option_category';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
